import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class DisallowChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.do('useDisallowedPositions', isChecked));
    }

    render() {
        const {stacking} = this.props;
        const isChecked = stacking.isDisallowedPositionsUsed();

        return <InputCheckbox label="Disallow" value="1" checked={isChecked} onChange={::this.onChange} />;
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking} = state;
    return {
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(DisallowChecking);
